import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useQueryUserRolesCurrentRole } from '../services/api/userRolesService';
import LoadingOverlay from '../shared/LoadingOverlay';
import { mutate } from 'swr';
import AccessDeniedPage from '../components/AccessDeniedPage';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, roles }) => {
  const { user, isLoading: isAuthLoading, isInitialized } = useAuth();
  const companyId = localStorage.getItem('companyId');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    // Only mutate if auth is initialized and user exists
    if (isInitialized && user && companyId && userId) {
      mutate('userRolesCurrentRole');
    }
  }, [companyId, userId, isInitialized, user]);

  const { data: currentRole, isLoading: isLoadingCurrentRole } =
    useQueryUserRolesCurrentRole(
      // Only fetch if auth is ready and we have required data
      isInitialized && user && companyId && userId ? { companyId: companyId, vitaUserId: userId } : null,
      {
        revalidateIfStale: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
      }
    );

  // Show loading while auth is initializing or user role is loading
  if (isAuthLoading || !isInitialized || (user && isLoadingCurrentRole)) {
    return <LoadingOverlay />;
  }

  // If no user after auth initialization, redirect to login
  if (isInitialized && !user) {
    return <Navigate to="/" replace />;
  }

  // If no company selected, redirect to company selection
  if (user && !companyId) {
    return <Navigate to="/empresas" replace />;
  }

  // Check role permissions
  const hasValidRole = currentRole?.data && roles.includes(currentRole.data.userRole);

  return hasValidRole ? children : <AccessDeniedPage />;
};

export default PrivateRoute;
